import { jsx as _jsx } from "react/jsx-runtime";
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { TrackerContext } from '../../context/TrackerContext';
import { APP_NAME, buildLink, DOMAIN_NAME } from '../../utils/urls';
import CUIButton from '../CUIButton/CUIButton';

const CUILoginButton = ({
  trackingIdentifier,
  variant = 'secondary'
}) => {
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsx(CUIButton, {
    variant: variant,
    as: "a",
    href: `${getFullUrl('app')}/login/?loginRedirectUrl=${encodeURIComponent(buildLink('', {
      domainOverride: DOMAIN_NAME.HUBSPOT,
      hubspotAppOverride: APP_NAME.AUTHED
    }))}&signupParams=${encodeURIComponent(JSON.stringify(['connect']))}`,
    onClick: () => trackInteraction('click login button', {
      identifier: trackingIdentifier
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connect.marketingSite.header.signInCTA"
    })
  });
};

export default CUILoginButton;